/**
 * Walkthrough demo videos for each Snagcart module.
 * Files live under frontend/public/pitch/demo-video/modules/
 * (copied from demo-video-kit/videos/).
 */

export const MODULE_DEMO_VIDEOS = {
  'ai-cofounder': {
    title: 'AI Co-founder walkthrough',
    src: '/pitch/demo-video/modules/01-ai-cofounder.mp4',
    durationLabel: '~2 min',
  },
  'ai-tools': {
    title: 'AI Tools walkthrough',
    src: '/pitch/demo-video/modules/02-ai-tools.mp4',
    durationLabel: '~2 min',
  },
  'media-studio': {
    title: 'Media Studio walkthrough',
    src: '/pitch/demo-video/modules/03-media-studio.mp4',
    durationLabel: '~2 min',
  },
  'bot-leads': {
    title: 'Bot Leads & Calls walkthrough',
    src: '/pitch/demo-video/modules/04-bot-leads.mp4',
    durationLabel: '~2 min',
  },
  'voice-campaigns': {
    title: 'Voice Campaigns walkthrough',
    src: '/pitch/demo-video/modules/05-voice-campaigns.mp4',
    durationLabel: '~2 min',
  },
  // Platform Guide section id is `domains`
  domains: {
    title: 'Domains & Hosting walkthrough',
    src: '/pitch/demo-video/modules/06-domains-hosting.mp4',
    durationLabel: '~2 min',
  },
  'domains-hosting': {
    title: 'Domains & Hosting walkthrough',
    src: '/pitch/demo-video/modules/06-domains-hosting.mp4',
    durationLabel: '~2 min',
  },
  'marketing-suite': {
    title: 'Marketing Suite walkthrough',
    src: '/pitch/demo-video/modules/07-marketing-suite.mp4',
    durationLabel: '~2 min',
  },
  'ai-seo': {
    title: 'AI SEO walkthrough',
    src: '/pitch/demo-video/modules/08-ai-seo.mp4',
    durationLabel: '~2 min',
  },
  'ai-ads': {
    title: 'AI Ads walkthrough',
    src: '/pitch/demo-video/modules/09-ai-ads.mp4',
    durationLabel: '~2 min',
  },
  automations: {
    title: 'Automations walkthrough',
    src: '/pitch/demo-video/modules/10-automations.mp4',
    durationLabel: '~2 min',
  },
  'ai-studio': {
    title: 'AI Studio walkthrough',
    src: '/pitch/demo-video/modules/11-ai-studio.mp4',
    durationLabel: '~2 min',
  },
  'lead-scraper': {
    title: 'Lead Scraper walkthrough',
    src: '/pitch/demo-video/modules/12-lead-scraper.mp4',
    durationLabel: '~2 min',
  },
  'create-from-template': {
    title: 'Create from Template walkthrough',
    src: '/pitch/demo-video/modules/13-create-from-template.mp4',
    durationLabel: '~2 min',
  },
  generate: {
    title: 'Create from Template walkthrough',
    src: '/pitch/demo-video/modules/13-create-from-template.mp4',
    durationLabel: '~2 min',
  },
  websites: {
    title: 'Create from Template walkthrough',
    src: '/pitch/demo-video/modules/13-create-from-template.mp4',
    durationLabel: '~2 min',
  },
  snagbuilder: {
    title: 'Snag Builder walkthrough',
    src: '/pitch/demo-video/modules/14-snagbuilder.mp4',
    durationLabel: '~2 min',
  },
  alifullstack: {
    title: 'Snag Builder walkthrough',
    src: '/pitch/demo-video/modules/14-snagbuilder.mp4',
    durationLabel: '~2 min',
  },
};

export function getModuleDemoVideo(moduleKey) {
  if (!moduleKey) return null;
  return MODULE_DEMO_VIDEOS[String(moduleKey).trim().toLowerCase()] || null;
}
